// Top-of-page marquee for admin-scheduled announcements. Filters
// only `rolling` banners; hides itself if there are none or while a
// full-screen modal (e.g. Fit Quiz) is open.
import useHideOnModal from "../../hooks/useHideOnModal";

export default function RollingBanner({ banners }) {
  const hiddenByModal = useHideOnModal();
  const rolling = banners.filter((b) => b.type === "rolling");
  if (rolling.length === 0 || hiddenByModal) return null;
  // Use green bg if any green banner exists, otherwise first banner's color
  const greenBanner = rolling.find((b) => b.bg_color === "#059669");
  const bgColor = greenBanner ? greenBanner.bg_color : rolling[0].bg_color;
  const textColor = greenBanner ? greenBanner.text_color : rolling[0].text_color;
  const text = rolling.map((b) => b.text).join("  \u00A0\u00A0\u2022\u00A0\u00A0  ");
  return (
    <div className="overflow-hidden py-2.5 relative z-[60]" style={{ background: bgColor, color: textColor }} data-testid="rolling-banner">
      <div className="flex animate-marquee whitespace-nowrap text-sm font-semibold">
        <span className="inline-block px-4">{text}</span>
        <span className="inline-block px-4">{text}</span>
        <span className="inline-block px-4">{text}</span>
        <span className="inline-block px-4">{text}</span>
      </div>
      <style>{`@keyframes marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } } .animate-marquee { animation: marquee 25s linear infinite; }`}</style>
    </div>
  );
}
